import React from 'react';

import ModalSlider from './ModalSlider';
import ModalSink from './ModalVariable/ModalSink';
import ModalStand from './ModalVariable/ModalStand';
import ModalTableTop from './ModalVariable/ModalTableTop';
import ModalMirror from './ModalVariable/ModalMirror';
import ModalForm from './ModalVariable/ModalForm';
import ModalCabinet from './ModalVariable/ModalCabinet';
import { initVariableFlaps } from '../utils/flaps/flaps-variable';


export default class ModalWindow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validateParts: false,
            validatePart: {
                stand: false,
                sink: false,
                tabletop: false,
                mirror: false,
                form: false,
            },
            price: ''
        }

        this.modalStandRef = React.createRef();
        this.modalSinkRef = React.createRef();
        this.modalTabletopRef = React.createRef();
        this.modalMirrorRef = React.createRef();
        this.modalCabinetRef = React.createRef();
        this.modalFormRef = React.createRef();
    }

    componentDidMount() {
        this._initTables();
    }

    async _initTables() {
        await initVariableFlaps().then(() => {})
    }

    componentDidUpdate(prevProps) {
        if(this.props.status === true && prevProps.status === false) {
            this.setState(state => {
                return {
                    price: '',
                    validatePart: {
                        stand: false,
                        sink: false,
                        tabletop: false,
                        cabinet: false,
                        mirror: false,
                        form: false,
                    }
                }
            })
        }

    }

    updateValidate(type, status) {
        const copyValidatePart = JSON.parse(JSON.stringify(this.state.validatePart));
        copyValidatePart[type] = status;
        this.setState(state => {
            return {validatePart: copyValidatePart}
        })
    }

    updatePrice(value) {
        this.setState(state => {
            return {
                price: `${value} рублей`
            }
        })
    }

    _setValidateParts(value) {
        this.setState(state => {
            return {
                validateParts: value,
            }
        })
    }

    render() {

        //validate button
        const validStand = this.props.type === 'stand' && this.state.validatePart.stand;
        const validSink = this.props.type === 'sink' && this.state.validatePart.sink;
        const validTabletop = this.props.type === 'tabletop' && this.state.validatePart.tabletop;
        const validaMirror = this.props.type === 'mirror' && this.state.validatePart.mirror;
        const validCabinet = this.props.type === 'cabinet' && this.state.validatePart.cabinet;
        const validFrom = this.props.type === 'form' && this.state.validatePart.form;
        const validateButton = validStand || validSink || validTabletop || validaMirror || validCabinet || validFrom ;

        //title modal

        const title = this.props.type==='stand' && this.props.currentStandList.length > 0 ? this.props.currentStandList[0].name :
        this.props.type==='sink' && this.props.currentSinks.length > 0 ? this.props.currentSinks[0].name :
        this.props.type==='tabletop' ? 'Столешницы' :
        this.props.type==='mirror' && this.props.currentMirrorList.length > 0 ? this.props.currentMirrorList[0].name :
        this.props.type==='cabinet' && this.props.currentCabinetList.length > 0 ? this.props.currentCabinetList[0].name : 
        this.props.type==='form' ? 'Оформление заказа' : '';

        //subtitle
        const subtitle = this.props.type==='stand' && this.props.currentStandList.length > 0 ? `Тумбы, Коллекция ${this.props.currentStandList[0].fileName}` :
        this.props.type==='sink' ? 'Раковины' :
        this.props.type==='mirror' ? 'Зеркала' :
        this.props.type==='cabinet' ? 'Пеналы' :
        this.props.type==='tabletop' ? '' : '';

        const imgForModal = this.props.sliderImgs ? this.props.sliderImgs.length > 0 ? this.props.sliderImgs[0] : '' : ''
        return(
            <div className={`modal-window ${this.props.status ? 'modal-window--active' : ''} ${this.props.type==='form' ? 'modal-window--form' : ''}`} 
                onClick={(e) => {
                    e.stopPropagation();
                    this.props.setStatusWindow({value: false, type: ''});
                }}
            >
                <div onClick={(e) => {e.stopPropagation()}} className={`modal-window__wrapper ${this.props.status ? 'modal-window__wrapper--active' : ''}`}>
                    <div className={`modal-window__wrap`}>
                        {window.innerWidth >= 1200 ?
                            <button className="modal-window__close" onClick={(e) => {
                                e.stopPropagation();
                                this.props.setStatusWindow({value: false, type: ''});
                                this._setValidateParts(false);
                            }}>
                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L18 18M18 18L35 35M18 18L35 1M18 18L1 35" stroke="black" strokeWidth="2"/>
                                </svg>
                            </button>
                            :
                            <button className="modal-window__close" onClick={() => {
                                    this.props.setStatusWindow(false)
                                    this._setValidateParts(false);
                                }}>
                                <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 1L2 8L9 15" stroke="black" strokeWidth="2"/>
                                </svg>
                                Назад
                            </button>
                        }

                        <div className='modal-window__header'>
                            <h1 ref={this.titleRef} className='modal-window__title'>
                                {title}
                            </h1>
                            {
                                this.props.type !== 'tabletop' ? 
                                <span className='modal-window__subtitle'>
                                    {subtitle}
                                </span>
                                :
                                <></>
                            }
                            
                        </div>
                        <div className='modal-window__content'>
                            {
                                this.props.type === 'stand' ? 
                                <ModalStand 
                                    config = {this.props.config}
                                    srcConfig = {this.props.srcConfig}
                                    setConfiguration = {this.props.setConfiguration}
                                    variableOptions = {this.props.variableOptions}
                                    img = {imgForModal}
                                    ref = {this.modalStandRef}
                                    validateParts = {this.state.validateParts}
                                    currentStandList = {this.props.currentStandList}
                                    updateValidate = {this.updateValidate.bind(this)}
                                    updatePrice = {this.updatePrice.bind(this)}
                                /> 
                                : 
                                <></>
                            }
                            {
                                this.props.type === 'sink' ? 
                                <ModalSink
                                    config = {this.props.config}
                                    srcConfig = {this.props.srcConfig}
                                    setConfiguration = {this.props.setConfiguration}
                                    validateParts = {this.state.validateParts}
                                    img = {imgForModal}
                                    ref = {this.modalSinkRef}
                                    updatePrice = {this.updatePrice.bind(this)}
                                    updateValidate = {this.updateValidate.bind(this)}
                                    currentSinkList = {this.props.currentSinks}
                                    updatePreloader = {this.props.updatePreloader}
                                /> 
                                : 
                                <></>
                            }
                            {
                                this.props.type === 'tabletop' ? 
                                <ModalTableTop
                                    config = {this.props.config}
                                    srcConfig = {this.props.srcConfig}
                                    setConfiguration = {this.props.setConfiguration}
                                    validateParts = {this.state.validateParts}
                                    img = {imgForModal}
                                    ref = {this.modalTabletopRef}
                                    updatePrice = {this.updatePrice.bind(this)}
                                    updateValidate = {this.updateValidate.bind(this)}
                                    currentTabletopsList = {this.props.currentTabletops}
                                    allVariableSink = {this.props.allVariableSinks}
                                    currentStand = {this.props.currentStandList.find(item => item.code === this.props.srcConfig.stand.article)}
                                /> 
                                : 
                                <></>
                            }
                            {
                                this.props.type === 'mirror' ?
                                <ModalMirror
                                    config = {this.props.config}
                                    srcConfig = {this.props.srcConfig}
                                    setConfiguration = {this.props.setConfiguration}
                                    validateParts = {this.state.validateParts}
                                    img = {imgForModal}
                                    ref = {this.modalMirrorRef}
                                    updatePrice = {this.updatePrice.bind(this)}
                                    updateValidate = {this.updateValidate.bind(this)}
                                    currentMirrorList = {this.props.currentMirrorList}
                                />
                                :
                                <></>
                            }

                            {
                                this.props.type === 'form' ?
                                <ModalForm 
                                    validateParts = {this.state.validateParts} 
                                    updateNoticeStatus = {this.props.updateNoticeStatus}
                                    updateValidate = {this.updateValidate.bind(this)}
                                    setStatusCheckout = {this.props.setStatusCheckout}
                                    changeCurrentStage = {this.props.changeCurrentStage}
                                    updatePreloader = {this.props.updatePreloader}
                                    config = {this.props.config}
                                    ref = {this.modalFormRef}
                                    generatePdf = {() => this.props.generatePdf()}
                                />
                                :
                                <></>
                            }
                            {
                                this.props.type === 'cabinet' ?
                                <ModalCabinet
                                    config = {this.props.config}
                                    secondColor={this.props.variableOptions.cabinetsBicolor}
                                    srcConfig = {this.props.srcConfig}
                                    setConfiguration = {this.props.setConfiguration}
                                    ref = {this.modalCabinetRef}
                                    validateParts = {this.state.validateParts}
                                    currentCabinetList = {this.props.currentCabinetList}
                                    updateValidate = {this.updateValidate.bind(this)}
                                    updatePrice = {this.updatePrice.bind(this)}
                                />
                                :
                                <></>
                            }
                            {
                                (this.props.type === "stand" || this.props.type === "sink" || this.props.type === "mirror" || this.props.type === "cabinet") && imgForModal ? 
                                    <div className='modal-window__show'>
                                        {window.innerWidth >= 1200  && this.props.status ?
                                            <>
                                                {
                                                    this.props.sliderImgs.map((img, i) => {
                                                        return <img src={img} key={i} alt="show"/>
                                                    })
                                                }
                                            </>
                                            :
                                            <ModalSlider slides = {this.props.sliderImgs} status = {this.props.status}/>
                                        }
                                    </div>
                                    :
                                    <></>
                            }
                            {
                                this.props.type !== 'form' && this.props.type !== 'tabletop'  ?
                                <div className='modal-window__description'>
                                    <p className='modal-window__description-text'>
                                        <span className='modal-window__description-subtitle'>описание</span>
                                        {this.props.description}
                                    </p>
                                </div>
                                :
                                ''
                            }
                            
                        </div>
                        <button 
                            className={`modal-window__submit-button ${validateButton ? '' : 'modal-window__submit-button--disabled'} button button--default-icon`}
                            onClick={() => {
                                if(validateButton) {
                                    this.props.updateNoticeStatus(false);
                                    // this._updateData();
                                    if(this.props.type === 'stand')
                                    this.modalStandRef.current.setStand();
                                    if(this.props.type === 'sink')
                                    this.modalSinkRef.current.setSink();
                                    if(this.props.type === 'tabletop')
                                    this.modalTabletopRef.current.setTabletop();
                                    if(this.props.type === 'mirror')
                                    this.modalMirrorRef.current.setMirror();
                                    if(this.props.type === 'cabinet')
                                    this.modalCabinetRef.current.setCabinet();
                                    if(this.props.type === 'form')
                                    this.modalFormRef.current.sendToBackend();
                                    this.props.setStatusWindow({value: false, type: ''});
                                    this._setValidateParts(false);
                                }
                                else {
                                    this._setValidateParts(true);
                                    this.props.updateNoticeStatus(true);
                                }
                                
                            }}
                        >
                            <div className="button__content">
                                <span>{this.state.price}</span>
                                <span>{this.props.type === 'form' ? 'Оформить заказ' : 'Сохранить и вернуться'}</span>
                            </div>
                            <svg width="58" height="16" viewBox="0 0 58 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M57.7071 8.70711C58.0976 8.31658 58.0976 7.68342 57.7071 7.29289L51.3431 0.928932C50.9526 0.538408 50.3195 0.538408 49.9289 0.928932C49.5384 1.31946 49.5384 1.95262 49.9289 2.34315L55.5858 8L49.9289 13.6569C49.5384 14.0474 49.5384 14.6805 49.9289 15.0711C50.3195 15.4616 50.9526 15.4616 51.3431 15.0711L57.7071 8.70711ZM0 9H57V7H0V9Z" fill="#F9F9F9"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}